export default "__VITE_ASSET__Bht249if__"